import React, { useContext } from 'react'
import UserContext from '../UserContext'

type LogoutProps = { path: string }

const Logout: React.FC<LogoutProps> = () => {
    const userContext = useContext(UserContext)

    if (userContext.token) {
        setTimeout(() => {
            userContext.logoutUser()
        },100)
    }

    return (
        <div className="no-records">
            <img src="/spinning-circles.svg" alt="loading" />
        </div>
    )
}

export default Logout